import { post } from '@alltrails/core/utils/post';
import type { PlaceLocation } from '@alltrails/explore-service/types/ExploreServiceLocation';
import type ExploreServiceResponse from '@alltrails/explore-service/types/ExploreServiceResponse';

export default async function getPlace(location: PlaceLocation) {
  return post<ExploreServiceResponse<any>>(`/api/alltrails/explore/v1/search`, {
    resultsToInclude: ['place'],
    location
  });
}
